/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Divider,
  Flex,
  Grid,
  Heading,
  SelectField,
  Text,
  TextAreaField,
  TextField,
} from "@aws-amplify/ui-react";
import { EmissionsNarrative } from "../models";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { DataStore } from "aws-amplify/datastore";
export default function EmissionsNarrativeUpdateForm(props) {
  const {
    id: idProp,
    emissionsNarrative: emissionsNarrativeModelProp,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    DataSetName: "",
    EmissionMeasurementStandard: "",
    EmissionConsolidationApproach: "",
    EmissionFactorsSource: "",
  };
  const [DataSetName, setDataSetName] = React.useState(
    initialValues.DataSetName
  );
  const [EmissionMeasurementStandard, setEmissionMeasurementStandard] =
    React.useState(initialValues.EmissionMeasurementStandard);
  const [EmissionConsolidationApproach, setEmissionConsolidationApproach] =
    React.useState(initialValues.EmissionConsolidationApproach);
  const [EmissionFactorsSource, setEmissionFactorsSource] = React.useState(
    initialValues.EmissionFactorsSource
  );
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    const cleanValues = emissionsNarrativeRecord
      ? { ...initialValues, ...emissionsNarrativeRecord }
      : initialValues;
    setDataSetName(cleanValues.DataSetName);
    setEmissionMeasurementStandard(cleanValues.EmissionMeasurementStandard);
    setEmissionConsolidationApproach(cleanValues.EmissionConsolidationApproach);
    setEmissionFactorsSource(cleanValues.EmissionFactorsSource);
    setErrors({});
  };
  const [emissionsNarrativeRecord, setEmissionsNarrativeRecord] =
    React.useState(emissionsNarrativeModelProp);
  React.useEffect(() => {
    const queryData = async () => {
      const record = idProp
        ? await DataStore.query(EmissionsNarrative, idProp)
        : emissionsNarrativeModelProp;
      setEmissionsNarrativeRecord(record);
    };
    queryData();
  }, [idProp, emissionsNarrativeModelProp]);
  React.useEffect(resetStateValues, [emissionsNarrativeRecord]);
  const validations = {
    DataSetName: [],
    EmissionMeasurementStandard: [],
    EmissionConsolidationApproach: [],
    EmissionFactorsSource: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          DataSetName,
          EmissionMeasurementStandard,
          EmissionConsolidationApproach,
          EmissionFactorsSource,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await DataStore.save(
            EmissionsNarrative.copyOf(emissionsNarrativeRecord, (updated) => {
              Object.assign(updated, modelFields);
            })
          );
          if (onSuccess) {
            onSuccess(modelFields);
          }
        } catch (err) {
          if (onError) {
            onError(modelFields, err.message);
          }
        }
      }}
      {...getOverrideProps(overrides, "EmissionsNarrativeUpdateForm")}
      {...rest}
    >
      <Heading
        level={4}
        children="Additional GHG Emissions Data"
        {...getOverrideProps(overrides, "SectionalElement0")}
      ></Heading>
      <Heading
        children="NZCS1 paragraph 24a-d."
        {...getOverrideProps(overrides, "SectionalElement4")}
      ></Heading>
      <Text
        children="Update this record that describes additional data in relation to your GHG emissions."
        {...getOverrideProps(overrides, "SectionalElement1")}
      ></Text>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement2")}
      ></Divider>
      <TextField
        label="Name of additional GHG Emissions data set"
        isRequired={false}
        isReadOnly={false}
        value={DataSetName}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              DataSetName: value,
              EmissionMeasurementStandard,
              EmissionConsolidationApproach,
              EmissionFactorsSource,
            };
            const result = onChange(modelFields);
            value = result?.DataSetName ?? value;
          }
          if (errors.DataSetName?.hasError) {
            runValidationTasks("DataSetName", value);
          }
          setDataSetName(value);
        }}
        onBlur={() => runValidationTasks("DataSetName", DataSetName)}
        errorMessage={errors.DataSetName?.errorMessage}
        hasError={errors.DataSetName?.hasError}
        {...getOverrideProps(overrides, "DataSetName")}
      ></TextField>
      <TextAreaField
        label="Describe the standard or standards your GHG emissions have been measured in accordance with"
        isRequired={false}
        isReadOnly={false}
        value={EmissionMeasurementStandard}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              DataSetName,
              EmissionMeasurementStandard: value,
              EmissionConsolidationApproach,
              EmissionFactorsSource,
            };
            const result = onChange(modelFields);
            value = result?.EmissionMeasurementStandard ?? value;
          }
          if (errors.EmissionMeasurementStandard?.hasError) {
            runValidationTasks("EmissionMeasurementStandard", value);
          }
          setEmissionMeasurementStandard(value);
        }}
        onBlur={() =>
          runValidationTasks(
            "EmissionMeasurementStandard",
            EmissionMeasurementStandard
          )
        }
        errorMessage={errors.EmissionMeasurementStandard?.errorMessage}
        hasError={errors.EmissionMeasurementStandard?.hasError}
        {...getOverrideProps(overrides, "EmissionMeasurementStandard")}
      ></TextAreaField>
      <SelectField
        label="Emission consolidation approach (equity share, financial control, or operational control)"
        placeholder="Please select an option"
        isDisabled={false}
        value={EmissionConsolidationApproach}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              DataSetName,
              EmissionMeasurementStandard,
              EmissionConsolidationApproach: value,
              EmissionFactorsSource,
            };
            const result = onChange(modelFields);
            value = result?.EmissionConsolidationApproach ?? value;
          }
          if (errors.EmissionConsolidationApproach?.hasError) {
            runValidationTasks("EmissionConsolidationApproach", value);
          }
          setEmissionConsolidationApproach(value);
        }}
        onBlur={() =>
          runValidationTasks(
            "EmissionConsolidationApproach",
            EmissionConsolidationApproach
          )
        }
        errorMessage={errors.EmissionConsolidationApproach?.errorMessage}
        hasError={errors.EmissionConsolidationApproach?.hasError}
        {...getOverrideProps(overrides, "EmissionConsolidationApproach")}
      >
        <option
          children="Equity share"
          value="Equity_Share"
          {...getOverrideProps(
            overrides,
            "EmissionConsolidationApproachoption0"
          )}
        ></option>
        <option
          children="Financial control"
          value="Financial_Control"
          {...getOverrideProps(
            overrides,
            "EmissionConsolidationApproachoption1"
          )}
        ></option>
        <option
          children="Operational control"
          value="Operational_Control"
          {...getOverrideProps(
            overrides,
            "EmissionConsolidationApproachoption2"
          )}
        ></option>
      </SelectField>
      <TextAreaField
        label="Describe the source of emission factors and global warming potential (GWP) rates used or a reference to the GWP source"
        isRequired={false}
        isReadOnly={false}
        value={EmissionFactorsSource}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              DataSetName,
              EmissionMeasurementStandard,
              EmissionConsolidationApproach,
              EmissionFactorsSource: value,
            };
            const result = onChange(modelFields);
            value = result?.EmissionFactorsSource ?? value;
          }
          if (errors.EmissionFactorsSource?.hasError) {
            runValidationTasks("EmissionFactorsSource", value);
          }
          setEmissionFactorsSource(value);
        }}
        onBlur={() =>
          runValidationTasks("EmissionFactorsSource", EmissionFactorsSource)
        }
        errorMessage={errors.EmissionFactorsSource?.errorMessage}
        hasError={errors.EmissionFactorsSource?.hasError}
        {...getOverrideProps(overrides, "EmissionFactorsSource")}
      ></TextAreaField>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement3")}
      ></Divider>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Reset"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          isDisabled={!(idProp || emissionsNarrativeModelProp)}
          {...getOverrideProps(overrides, "ResetButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={
              !(idProp || emissionsNarrativeModelProp) ||
              Object.values(errors).some((e) => e?.hasError)
            }
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
